import { SxProps, Typography, Theme } from "@mui/material";

export interface CaptionProps {
  text: string;
  className?: string;
  style?: React.CSSProperties;
  bold?: boolean;
  sx?: SxProps<Theme>;
}
export const Caption = (props: CaptionProps) => {
  return (
    <Typography
      variant="caption"
      color="textSecondary"
      className={props.className}
      sx={props.sx || {}}
      style={{
        ...props.style,
        // fontVariant: "small-caps",
        fontWeight: props.bold ? "bold" : undefined,
      }}>
      {props.text}
    </Typography>
  );
};

export default Caption;
